var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsercheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8005 34.1934L28.1339 38.5267L41.1339 25.5267M2.13385 38.5267V36.36C2.13385 30.3769 6.9841 25.5267 12.9672 25.5267H21.0922M25.9672 10.36C25.9672 15.1465 22.087 19.0267 17.3005 19.0267C12.514 19.0267 8.63385 15.1465 8.63385 10.36C8.63385 5.57356 12.514 1.69336 17.3005 1.69336C22.087 1.69336 25.9672 5.57356 25.9672 10.36Z",
    stroke: "#5CBD20",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsercheck);
export default __webpack_public_path__ + "static/media/usercheck.44655a3dfcc6cf4f4c4b455d158b83e3.svg";
export { ForwardRef as ReactComponent };